import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  routes,
  otherRoutes,
  teamOwnerRoutes,
  adminRoutes,
  teamAdminRoutes,
} from "../utils/data/routes";
import {
  loggedInUser,
  teamIDCheck,
  accountType,
  subscribedPackage,
  teamSubscribedPackage,
  isOwnerPackage,
  userIDCheck,
  subscriptionPackages,
  teamLogoAtom,
} from "../utils/store";
import chroma from "chroma-js";
import { applyCSSVariables, applyDarkTheme, applyLightTheme, applyBrandingColors } from "../utils/themeUtils";
import dummyimage from "../assets/images/global_icons/dummyimage.svg";
import logo from "../assets/images/sidebar_icons/logo-dark.svg";
import logoLight from "../assets/images/sidebar_icons/logo.svg";
import collapsedLogo from "../assets/images/sidebar_icons/collapsedLogoDark.svg";
import collapsedLogoLight from "../assets/images/sidebar_icons/collapsedLogo.svg";
import menu from "../assets/images/sidebar_icons/arrow-bar-left.svg";
// import classes from "../assets/styles/Sidebar.module.css";
import { useAtom } from "jotai";
import { BsPerson } from "react-icons/bs";
import { BiGroup } from "react-icons/bi";
import { RiArrowDownSLine } from "react-icons/ri";
import { IoIosLogOut } from "react-icons/io";
import { MdAccountBox } from "react-icons/md";
import showToast from "../helpers/showToast";
import useLogout from "../hooks/useLogout";
import baseUrl from "../utils/constants/baseUrl";
import {
  DELETE_USER_ACCOUNT,
  DELETE_OWNER_ACCOUNT,
  THEME_GET,
} from "../utils/constants/apiUrl";
import ConfirmationModal from "./Modals/ConfirmationModal";
import { deleteRecord, get } from "../server";
import { trackEvent } from "../utils/mixpanel";
import { Button, Image } from "react-bootstrap";
import { IoArrowForwardOutline } from "react-icons/io5";
import introJs from "intro.js";
import "intro.js/minified/introjs.min.css";

const Sidebar = ({
  isSidebarCollapsed,
  setIsSidebarCollapsed,
  handleHideSidebar,
}) => {
  const [userID, setUserID] = useAtom(userIDCheck);
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [teamPurchasedPackage, setTeamPurchasedPackage] = useAtom(teamSubscribedPackage);
  const [purchasePackages] = useAtom(subscriptionPackages);
  const [isOwnerPackageActive, setIsOwnerPackageActive] =
    useAtom(isOwnerPackage);
  const [, setTeamLogoUrl] = useAtom(teamLogoAtom);
  const [showModal, setShowModal] = useState(false);
  const logout = useLogout();
  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleConfirmDelete = async () => {
    handleCloseModal();
    if (loggedUser.role.includes("team_owner")) {
      let { status, message } = await deleteRecord(
        DELETE_OWNER_ACCOUNT,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
      if (status) {
        showToast(status, "Account Deleted Successfully");
        logout();
        navigate("/login");
      } else {
        showToast(status, message);
      }
    } else {
      let { status, message } = await deleteRecord(
        DELETE_USER_ACCOUNT,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
      if (status) {
        showToast(status, "Account Deleted Successfully");
        logout();
        navigate("/login");
      } else {
        showToast(status, message);
      }
    }
  };
  const handleSwitchAccount = () => {
    const withTeamIdData = loggedUser?.secret_code?.filter(
      (item) => item.team_id !== null
    );
    
    console.log("[handleSwitchAccount] Starting switch");
    console.log("[handleSwitchAccount] personalAccount:", personalAccount);
    console.log("[handleSwitchAccount] teamPurchasedPackage:", teamPurchasedPackage);
    console.log("[handleSwitchAccount] localStorage teamPurchasedPackage:", localStorage.getItem("teamPurchasedPackage"));
    
    if (personalAccount) {
      // check if two roles and include team owner
      if (loggedUser?.role?.includes("team_owner")) {
        let teamID = withTeamIdData[0]?.team_id;
        console.log("[handleSwitchAccount] Team owner switching to team_id:", teamID);
        
        let teamPackage = loggedUser?.package_details?.find(
          (obj) => obj.team_id == teamID
        );
        console.log("[handleSwitchAccount] teamPackage from loggedUser.package_details:", teamPackage);

        // First, set the team mode state
        setUserTeamId(teamID);
        setPersonalAccount(false);
        setUserID(loggedUser?.teams?.user_id);
        
        let isTeamPackage = loggedUser?.package_details.filter(
          (obj) => obj.team_id == teamID
        );
        
        // null end_date = never-expiring; also check teamPurchasedPackage atom as fallback
        const hasValidTeamPackage =
          isTeamPackage.length > 0 &&
          (isTeamPackage[0]?.end_date === null ||
            new Date(isTeamPackage[0]?.end_date) > new Date());
        
        // Check both the atom and localStorage directly
        const hasStoredTeamPackage =
          teamPurchasedPackage && Object.keys(teamPurchasedPackage).length > 0;
        
        // Also check localStorage directly as a fallback - CRITICAL FIX
        let storedTeamPackageFromLS = null;
        try {
          const lsValue = localStorage.getItem("teamPurchasedPackage");
          console.log("[handleSwitchAccount] Raw localStorage value:", lsValue);
          if (lsValue && lsValue !== "null" && lsValue !== "undefined") {
            storedTeamPackageFromLS = JSON.parse(lsValue);
          }
        } catch (e) {
          console.error("[handleSwitchAccount] Error parsing localStorage:", e);
        }
        const hasStoredTeamPackageInLS = storedTeamPackageFromLS && Object.keys(storedTeamPackageFromLS).length > 0;

        console.log("[handleSwitchAccount] hasValidTeamPackage:", hasValidTeamPackage);
        console.log("[handleSwitchAccount] hasStoredTeamPackage:", hasStoredTeamPackage);
        console.log("[handleSwitchAccount] hasStoredTeamPackageInLS:", hasStoredTeamPackageInLS);
        console.log("[handleSwitchAccount] storedTeamPackageFromLS:", storedTeamPackageFromLS);
        console.log("[handleSwitchAccount] teamPurchasedPackage keys:", Object.keys(teamPurchasedPackage || {}));

        if (hasValidTeamPackage || hasStoredTeamPackage || hasStoredTeamPackageInLS) {
          // Set the appropriate package and FORCE persist to localStorage
          let packageToSet = null;
          
          if (hasValidTeamPackage && teamPackage) {
            console.log("[handleSwitchAccount] Using team package from loggedUser");
            packageToSet = purchasePackages.find(p => p.id == teamPackage?.package_id) || teamPackage?.package || teamPackage;
          } else if (hasStoredTeamPackageInLS) {
            console.log("[handleSwitchAccount] Using stored team package from localStorage:", storedTeamPackageFromLS);
            packageToSet = purchasePackages.find(p => p.id == storedTeamPackageFromLS?.package_id || storedTeamPackageFromLS?.id) || storedTeamPackageFromLS?.package || storedTeamPackageFromLS;
          } else if (hasStoredTeamPackage) {
            console.log("[handleSwitchAccount] Using stored team package from atom:", teamPurchasedPackage);
            packageToSet = purchasePackages.find(p => p.id == teamPurchasedPackage?.package_id || teamPurchasedPackage?.id) || teamPurchasedPackage?.package || teamPurchasedPackage;
          }
          
          if (packageToSet && Object.keys(packageToSet).length > 0) {
            setPurchasedPackage(packageToSet);
            setTeamPurchasedPackage(packageToSet);
            
            // CRITICAL: Force persist to localStorage to prevent future data loss
            console.log("[handleSwitchAccount] Force persisting packageToSet to localStorage:", packageToSet);
            localStorage.setItem("teamPurchasedPackage", JSON.stringify(packageToSet));
            localStorage.setItem("purchasedPackage", JSON.stringify(packageToSet));
          }
          
          setIsOwnerPackageActive(true);
          navigate("/team");
        } else {
          console.log("[handleSwitchAccount] No valid team package found, navigating to paymentNotPaid");
          navigate("/paymentNotPaid");
        }
      } else {
        const isSuspended = loggedUser?.team_members?.some(
          (member) => member.check_status === "suspended"
        );
        if (isSuspended) {
          showToast(
            false,
            "Your account has been suspended by admin, please contact support for further queries"
          );
        } else {
          let teamID = withTeamIdData[0]?.team_id;
          let isTeamPackage = loggedUser?.package_details.filter(
            (obj) => obj.team_id == teamID
          );
          const teamEndDate = isTeamPackage[0]?.end_date;
          const teamPackageValid =
            isTeamPackage.length > 0 &&
            (teamEndDate === null || new Date(teamEndDate) > new Date());
          
          // Also check localStorage as fallback for team members
          let storedTeamPackageFromLS = null;
          try {
            const lsValue = localStorage.getItem("teamPurchasedPackage");
            if (lsValue && lsValue !== "null" && lsValue !== "undefined") {
              storedTeamPackageFromLS = JSON.parse(lsValue);
            }
          } catch (e) {
            console.error("[handleSwitchAccount] Error parsing localStorage:", e);
          }
          
          if (!teamPackageValid && !teamPurchasedPackage?.id && !storedTeamPackageFromLS) {
            return showToast(
              false,
              "You can not switch to team mode because your team is not subscribed to any package"
            );
          }
          
          let teamPackage = loggedUser?.package_details?.find(
            (obj) => obj.team_id == teamID
          );
          
          // Use stored package if available
          const packageToSet = storedTeamPackageFromLS || 
            purchasePackages.find(p => p.id == teamPackage?.package_id) || 
            teamPackage?.package || 
            teamPackage ||
            teamPurchasedPackage;
            
          setPurchasedPackage(packageToSet);
          setTeamPurchasedPackage(packageToSet);
          
          // Force persist to localStorage
          if (packageToSet && Object.keys(packageToSet).length > 0) {
            localStorage.setItem("teamPurchasedPackage", JSON.stringify(packageToSet));
            localStorage.setItem("purchasedPackage", JSON.stringify(packageToSet));
          }
          
          setUserTeamId(withTeamIdData[0]?.team_id);
          setPersonalAccount(false);
          navigate("/");
        }
      }
    } else {
      let teamPackage = loggedUser?.package_details?.find(
        (obj) => obj.team_id == null
      );
      setIsOwnerPackageActive(false);
      const personalPackagePlan = purchasePackages.find(p => p.id == teamPackage?.package_id) || teamPackage?.package || teamPackage;
      setPurchasedPackage(personalPackagePlan);
      
      // Force persist personal package
      if (personalPackagePlan && Object.keys(personalPackagePlan).length > 0) {
        localStorage.setItem("purchasedPackage", JSON.stringify(personalPackagePlan));
      }
      
      setUserTeamId(null);
      setPersonalAccount(true);
      setUserID(null);
      setTeamLogoUrl("");
      navigate("/");
    }
  };

  // const handleSwitchAccount = () => {
  //   const withTeamIdData = loggedUser?.secret_code?.filter(
  //     (item) => item.team_id !== null
  //   );

  //   // no team data found
  //   if (!withTeamIdData?.length) {
  //     return showToast(false, "No team account found to switch.");
  //   }

  //   const teamID = withTeamIdData[0]?.team_id;

  //   console.log("teamID", teamID);

  //   if (personalAccount) {
  //     // --- Switching from Personal → Team mode ---
  //     alert("1");
  //     if (loggedUser?.role?.includes("team_owner")) {
  //       // Team Owner logic
  //       const teamPackage = loggedUser?.package_details?.find(
  //         (pkg) => pkg.team_id === teamID
  //       );
  //       alert("2");
  //       if (!teamPackage) {
  //         alert("3");
  //         navigate("/paymentNotPaid");
  //         return;
  //       }

  //       const currentDate = new Date();
  //       const endDate = new Date(teamPackage?.end_date);

  //       if (currentDate >= endDate) {
  //         alert("4");
  //         navigate("/paymentNotPaid");
  //         return;
  //       }
  //       alert("51");
  //       // Package valid
  //       setPurchasedPackage(teamPackage);
  //       setUserTeamId(teamID);
  //       setUserID(loggedUser?.teams?.user_id);
  //       setPersonalAccount(false);
  //       setIsOwnerPackageActive(true);
  //       navigate("/team");
  //     } else {
  //       alert("6");
  //       // --- For normal team members ---
  //       const isSuspended = loggedUser?.team_members?.some(
  //         (member) => member.check_status === "suspended"
  //       );

  //       if (isSuspended) {
  //         showToast(
  //           false,
  //           "Your account has been suspended by admin, please contact support for further queries."
  //         );
  //         return;
  //       }

  //       const teamPackage = loggedUser?.package_details?.find(
  //         (pkg) => pkg.team_id === teamID
  //       );

  //       if (!teamPackage) {
  //         showToast(
  //           false,
  //           "You cannot switch to team mode because your team is not subscribed to any package."
  //         );
  //         return;
  //       }

  //       const currentDate = new Date();
  //       const endDate = new Date(teamPackage?.end_date);

  //       if (currentDate >= endDate) {
  //         showToast(
  //           false,
  //           "Your team's subscription has expired. Please renew to continue."
  //         );
  //         return;
  //       }

  //       // Package valid
  //       setPurchasedPackage(teamPackage);
  //       setUserTeamId(teamID);
  //       setPersonalAccount(false);
  //       navigate("/");
  //       alert("7");
  //     }
  //   } else {
  //     // --- Switching from Team → Personal mode ---
  //     const personalPackage = loggedUser?.package_details?.find(
  //       (pkg) => pkg.team_id === null
  //     );

  //     setPurchasedPackage(personalPackage || null);
  //     setUserTeamId(null);
  //     setPersonalAccount(true);
  //     setIsOwnerPackageActive(false);
  //     setUserID(null);
  //     navigate("/");
  //   }
  // };

  const [openSubmenu, setOpenSubmenu] = useState({ open: false, name: "" });
  const handleClick = (level, text) => {
    if (level === 2) {
      if (openSubmenu.name === text) {
        setOpenSubmenu({ ...openSubmenu, open: !openSubmenu.open });
      } else {
        setOpenSubmenu({ open: true, name: text });
      }
    }
  };
  const navigate = useNavigate();
  const location = useLocation();

  // Helper to check if a sidebar item should be active.
  // NavLink's default isActive only works for nested routes;
  // for flat routes like /team we also need a pathname prefix check.
  const isRouteActive = (isActive, routePath) => {
    const isTeamMemberFunctionPage =
      /\/team\/[^/]+\/teamMembers\/member\/[^/]+\/function(?:\/|$)/.test(
        location.pathname
      );

    // Team-member function pages belong to the Function tab. Prevent the
    // parent Team route from being highlighted at the same time.
    if (isTeamMemberFunctionPage) {
      return routePath === "/function";
    }

    if (isActive) return true;
    // For non-root paths, check if the current URL starts with the route path
    if (routePath && routePath !== "/" && location.pathname.startsWith(routePath + "/")) {
      return true;
    }
    return false;
  };
  let routesData = routes;
  if (loggedUser && loggedUser?.role) {
    if (["sub_admin", "super_admin"].includes(loggedUser.role[0])) {
      // for Subroutes not show
      if (loggedUser.role[0] === "sub_admin") {
        routesData = adminRoutes.filter((el) => el.path !== "/adminUser");
      } else {
        routesData = adminRoutes;
      }
    }

    if (loggedUser.role?.includes("team_admin") && !personalAccount) {
      routesData = teamAdminRoutes;
    }

    // Non-owner team members should not see package or subscription billing
    // navigation. Team-owner routing remains unchanged below.
    const isTeamMember =
      (loggedUser?.connected_teams?.length ?? 0) > 0 &&
      !loggedUser.role?.includes("team_owner");
    if (isTeamMember) {
      routesData = routesData.filter(
        (route) =>
          route.path !== "/packages" &&
          route.path !== "/viewSubscription"
      );
    }

    // console.log("hasTeamPackage", hasTeamPackage);
    if (!personalAccount) {
      routesData = routesData.filter((el) => el.path !== "/packages");
    }
    // Handle routes for team owner
    // if (loggedUser.role?.includes("team_owner") && !personalAccount) {
    //   routesData = teamOwnerRoutes;
    // }
    // ✅ Handle routes for team_owner
    if (loggedUser.role?.includes("team_owner") && !personalAccount) {
      routesData = teamOwnerRoutes;
    }
  }
  const handleToggleSidebar = () => {
    setIsSidebarCollapsed((preValue) => !preValue);
  };
  const handleLogout = () => {
    logout();
  };
  const styles = {
    list: {
      margin: "85px 15px",
    },
    mainSubitem: {
      display: "flex",
      alignItems: "center",
      justifyContent: isSidebarCollapsed ? "center" : "space-between",
      padding: isSidebarCollapsed ? "22px 20px" : "0 15px",
      borderRadius: isSidebarCollapsed ? "10px" : "36px",
      color: "var(--primary_text_color)",
      gap: "10px",
      height: "40px",
      whiteSpace: "nowrap",
    },
  };
  const [theme, setTheme] = useState("");
  const [teamLogo, setTeamLogo] = useState("");
  const fetchColors = async (role) => {
    let { status, message, data } = await get(
      THEME_GET,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if ((role !== "super_admin" || role !== "sub_admin") && status) {
      const newThemeColor = data?.theme_color;
      const newButtonColor = data?.button_color;
      const teamData = data?.team;
      const effectiveButtonColor = teamData?.button_color || newButtonColor;
      const effectiveCardColor = teamData?.card_color || data?.card_color;
      const isDarkPreset =
        newThemeColor === "#000000" &&
        newButtonColor?.toLowerCase() === "#09a0ff";

      if (isDarkPreset) {
        // Dark theme preset: use applyDarkTheme, no team branding override
        setTheme("dark");
        applyDarkTheme();
      } else if (newThemeColor) {
        setTheme("light");
        applyCSSVariables(newThemeColor);
        // Team Branding custom: button color with fallback to default teal
        const effectiveBtn = effectiveButtonColor || "#529e83";
        applyBrandingColors(effectiveBtn, effectiveCardColor);
      } else {
        setTheme("light");
        // Light theme: use default --blue-color for buttons, only apply card branding
        applyLightTheme();
        applyBrandingColors(null, effectiveCardColor);
      }
      const teamLogoPath = teamData?.logo;
      const resolvedTeamLogoUrl = teamLogoPath
        ? (teamLogoPath.startsWith("http") || teamLogoPath.startsWith("data:")
            ? teamLogoPath
            : baseUrl.PUBLIC_URL + teamLogoPath)
        : "";
      if (resolvedTeamLogoUrl) {
        setTeamLogo(resolvedTeamLogoUrl);
        setTeamLogoUrl(resolvedTeamLogoUrl);
      }
      // Persist team branding into loggedUser.teams so all components can access it
      if (teamData && loggedUser?.id) {
        setLoggedUser((prev) => ({
          ...prev,
          teams: {
            ...(prev.teams || {}),
            logo: teamData.logo ?? prev.teams?.logo,
            card_background_image: teamData.card_background_image ?? prev.teams?.card_background_image,
            card_color: teamData.card_color ?? prev.teams?.card_color,
            card_logo_shape: teamData.card_logo_shape ?? prev.teams?.card_logo_shape,
          },
        }));
      }
    }
  };

  useEffect(() => {
    fetchColors();
    
    // CRITICAL FIX: On mount, verify localStorage persistence for team packages
    if (!personalAccount && loggedUser?.id && userTeamId) {
      const storedTeamPackage = localStorage.getItem("teamPurchasedPackage");
      
      // If localStorage is empty but we have package data in loggedUser, restore it
      if ((!storedTeamPackage || storedTeamPackage === "null" || storedTeamPackage === "{}") && 
          loggedUser?.package_details?.length > 0) {
        
        const teamPackage = loggedUser.package_details.find(
          (pkg) => pkg.team_id == userTeamId
        );
        
        if (teamPackage) {
          const packageToStore = teamPackage?.package || teamPackage;
          console.log("[Sidebar useEffect] Restoring lost team package to localStorage:", packageToStore);
          
          if (packageToStore && Object.keys(packageToStore).length > 0) {
            localStorage.setItem("teamPurchasedPackage", JSON.stringify(packageToStore));
            setTeamPurchasedPackage(packageToStore);
            setPurchasedPackage(packageToStore);
          }
        }
      }
    }
  }, [loggedUser?.id, personalAccount, userTeamId]);

  useEffect(() => {
    fetchColors();
  }, []);

  // const startWalkthrough = () => {
  //   introJs()
  //     .setOptions({
  //       showProgress: false,
  //       showBullets: false,
  //       exitOnOverlayClick: false,
  //       tooltipPosition: "auto",
  //       nextLabel: "Next",
  //       prevLabel: "Back",
  //       doneLabel: "Done",
  //     })
  //     .oncomplete(() => {
  //       localStorage.setItem("sidebarWalkthroughDone", "true");
  //     })
  //     .onexit(() => {
  //       localStorage.setItem("sidebarWalkthroughDone", "true");
  //     })
  //     .start();
  // };
  // useEffect(() => {
  //   if (routesData.length > 0) {
  //     setTimeout(() => {
  //       startWalkthrough();
  //     }, 500); // Give time to render sidebar items
  //   }
  // }, [routesData]);

  return (
    <>
      <aside
        className={isSidebarCollapsed ? "collapsedSidebar sidebar" : "sidebar"}
        style={{
          height:
            isSidebarCollapsed &&
            loggedUser.role[0] === "super_admin" &&
            "100%",
        }}
      >
        <div className="position-relative d-flex align-items-center justify-content-between sidebarLogo">
          {isSidebarCollapsed ? (
            <>
              {teamLogo ? (
                <img
                  src={teamLogo}
                  alt="logo"
                  onClick={handleToggleSidebar}
                  className="logoBtn"
                  style={{ width: 40, height: 40, objectFit: "contain", borderRadius: 6 }}
                />
              ) : theme === "dark" ? (
                <img
                  src={collapsedLogoLight}
                  alt="collapsedLogo"
                  onClick={handleToggleSidebar}
                  className="logoBtn"
                />
              ) : (
                <img
                  src={collapsedLogo}
                  alt="collapsedLogo"
                  onClick={handleToggleSidebar}
                  className="logoBtn"
                />
              )}
            </>
          ) : (
            <>
              {teamLogo ? (
                <img
                  src={teamLogo}
                  alt="logo"
                  style={{ maxHeight: 40, maxWidth: "68%", width: "auto", objectFit: "contain", display: "block" }}
                />
              ) : theme === "dark" ? (
                <img src={logoLight} alt="logo" />
              ) : (
                <img src={logo} alt="logo" />
              )}
            </>
          )}
          <div
            className={
              isSidebarCollapsed ? "toHideBtn toggle-btn" : "toggle-btn"
            }
          >
            <Button onClick={handleToggleSidebar}>
              <img src={menu} alt="menu" />
            </Button>
          </div>
        </div>

        <ul className="logOutList list-unstyled">
          {/* {loggedUser?.secret_code?.length === 2 && ( */}
          {(loggedUser?.connected_teams?.length ?? 0) > 0 ? (
            <li className="listItem">
              <div className="item switchAccount" style={{ cursor: "default" }}>
                <span>
                  <Image
                    src={baseUrl.PUBLIC_URL + loggedUser.profile_image}
                    width="30px"
                    height="30px"
                    loading="lazy"
                    decoding="async"
                    roundedCircle={true}
                    className="imageBackground"
                    onError={(e) => {
                      e.currentTarget.src = dummyimage;
                    }}
                  />
                </span>
                <div className="switchAccountContent">
                  <h6>{loggedUser?.name}</h6>
                  <p
                    style={{
                      display: isSidebarCollapsed ? "none" : "flex",
                      alignItems: "center",
                      gap: 4,
                      color: "var(--primary_text_color)",
                    }}
                    className="listItemText"
                  >
                    <span style={{
                      display: "inline-block",
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: "#22c55e",
                      flexShrink: 0,
                      marginRight: 0,
                    }} />
                    Team Mode is On
                  </p>
                </div>
              </div>
            </li>
          ) : (
            <li className="listItem" onClick={handleSwitchAccount}>
              <Link className="item switchAccount">
                <span>
                  <Image
                    src={baseUrl.PUBLIC_URL + loggedUser.profile_image}
                    width="30px"
                    height="30px"
                    loading="lazy"
                    decoding="async"
                    roundedCircle={true}
                    className="imageBackground"
                    onError={(e) => {
                      e.currentTarget.src = dummyimage;
                    }}
                  />
                </span>
                <div className="switchAccountContent">
                  <h6>{loggedUser?.name}</h6>
                  <p
                    style={{
                      display: isSidebarCollapsed ? "none" : "block",
                    }}
                    className="listItemText"
                  >
                    Switch to
                    {personalAccount ? " Team" : " Personal"}{" "}
                    <IoArrowForwardOutline className="ms-1" />
                  </p>
                </div>
              </Link>
            </li>
          )}
          {/* )} */}
          {/* <li className="listItem" onClick={() => handleLogout()}>
            <Link
              onClick={() => {
                trackEvent("Logout Successfully", {
                  timestamp: new Date().toISOString(),
                  source: "Sidebar Menu",
                });
              }}
              className="item"
            >
              <span>
                <IoIosLogOut style={{ color: "#E35252" }} />
              </span>
              <p className="listItemText">Log out</p>
            </Link>
          </li> */}
        </ul>
        <ul className="menu-list list-unstyled">
          {routesData.map((route, index) => {
            if (route.childrens) {
              return (
                <li
                  className="mainSubItem align-items-center"
                  key={`${route.id}-${route.text}`}
                  in={openSubmenu.open && openSubmenu.name === route.text}
                  // data-intro={
                  //   route.intro || `This is the ${route.text} section`
                  // }
                  // data-step={index + 1}
                >
                  <NavLink
                    to={route.path}
                    style={styles.mainSubitem}
                    onClick={() => handleClick(2, route.text)}
                  >
                    <div className="listItemContentWrapper align-items-center">
                      {/* <img src={route.icon} alt="" /> */}
                      <span> {route.icon}</span>
                      <p
                        style={{
                          display: isSidebarCollapsed ? "none" : "block",
                        }}
                        className="listItemText"
                      >
                        {route.text}
                      </p>
                    </div>
                    {isSidebarCollapsed ? null : (
                      <RiArrowDownSLine
                        style={{ transition: "all 0.3s ease" }}
                        className={
                          openSubmenu.open && openSubmenu.name === route.text
                            ? "rotateSubMenuIcon"
                            : null
                        }
                      />
                    )}
                  </NavLink>
                  {isSidebarCollapsed ? (
                    <ul className="adminPanelCollapsedSubmenu list-unstyled">
                      {route.childrens.map((child) => {
                        return (
                          <li
                            className="subMenuListItem"
                            key={`${child.id}=${child.text}`}
                          >
                            <NavLink
                              to={child.path}
                              className={({ isActive }) =>
                                isRouteActive(isActive, child.path) ? "item activeItem" : "item"
                              }
                            >
                              <span>{child.icon}</span>
                              <p
                                style={{
                                  display: isSidebarCollapsed
                                    ? "none"
                                    : "block",
                                }}
                                className="listItemText"
                              >
                                {child.text}
                              </p>
                            </NavLink>
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    <div
                      className={
                        openSubmenu.open && openSubmenu.name === route.text
                          ? "showSbmenuContent"
                          : "hideSbmenuContent d-none"
                      }
                    >
                      {route.childrens.map((child) => {
                        return (
                          <li
                            className="subMenuListItem"
                            key={`${child.id}-${child.text}`}
                          >
                            <NavLink
                              onClick={handleHideSidebar}
                              to={child.path}
                              className={({ isActive }) =>
                                isRouteActive(isActive, child.path) ? "item activeItem" : "item"
                              }
                            >
                              <span>{child.icon}</span>
                              <p
                                style={{
                                  display: isSidebarCollapsed
                                    ? "none"
                                    : "block",
                                }}
                                className="listItemText"
                              >
                                {child.text}
                              </p>
                            </NavLink>
                          </li>
                        );
                      })}
                    </div>
                  )}
                </li>
              );
            } else {
              return (
                <li
                  className="listItem"
                  key={`${route.id}-${route.text}`}
                  // data-intro={
                  //   route.intro || `This is the ${route.text} section`
                  // }
                  // data-step={index + 1}
                >
                  {route.text === "Shop" ? (
                    <a
                      href={route.path}
                      target="_blank"
                      rel="noreferrer"
                      className="item"
                      onClick={handleHideSidebar}
                    >
                      <span>{route.icon}</span>
                      <p className="listItemText">{route.text}</p>
                    </a>
                  ) : (
                    <NavLink
                      to={route.path}
                      onClick={handleHideSidebar}
                      className={({ isActive }) =>
                        isRouteActive(isActive, route.path) ? "item activeItem" : "item"
                      }
                    >
                      <span>{route.icon}</span>
                      <p
                        style={{
                          display: isSidebarCollapsed ? "none" : "block",
                        }}
                        className="listItemText"
                      >
                        {route.text}
                      </p>
                    </NavLink>
                  )}
                </li>
              );
            }
          })}
          {(loggedUser?.role?.includes("customer") ||
            loggedUser?.role?.includes("team_owner")) && (
            <>
              {otherRoutes.map((route) => {
                return (
                  <li className="listItem" key={`${route.id} = ${route.text}`}>
                    <NavLink
                      onClick={handleHideSidebar}
                      to={route.path}
                      className={({ isActive }) =>
                        isRouteActive(isActive, route.path) ? "item activeItem" : "item"
                      }
                    >
                      <span>{route.icon}</span>
                      <p
                        style={{
                          display: isSidebarCollapsed ? "none" : "block",
                        }}
                        className="listItemText"
                      >
                        {route.text}
                      </p>
                    </NavLink>
                  </li>
                );
              })}
              {/* <li className="listItem" onClick={handleShowModal}>
              <Link className="item">
                <span>
                  <MdAccountBox />
                </span>
                <p
                  style={{
                    display: isSidebarCollapsed ? "none" : "block",
                  }}
                  className="listItemText"
                >
                  Delete Account
                </p>
              </Link>
            </li> */}
            </>
          )}
        </ul>
      </aside>
      {showModal && (
        <ConfirmationModal
          show={showModal}
          deleteAccountMessage={
            loggedUser?.role?.includes("team_owner") ||
            loggedUser?.role?.includes("team_admin") ||
            (loggedUser?.role?.includes("customer") &&
              loggedUser?.secret_code?.length > 1)
              ? "By deleting your account, all your personal, team related data and team subscription will be lost and it can't be recovered."
              : "By deleting your account, all your data will be lost and it can't be recovered."
          }
          confirmTitle="account"
          handleCloseModal={handleCloseModal}
          handleConfirmDelete={handleConfirmDelete}
        />
      )}
    </>
  );
};
export default Sidebar;
